import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { hasRole, hasSupervisorPermission } from '@heyjob-dash/shared/utils/check-permission';

import { paths } from 'src/routes/paths';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

// Gate rotte in base a un permesso del profilo Responsabile (es. registry_access).
// Complementa il gate UI del menu; qui blocca l'accesso via URL diretto.
// Azienda/Studio/Operatore passano sempre (hasSupervisorPermission → true).
//
// `orRoles`: ruoli Cognito che passano comunque, per le sezioni che erano già
// aperte a un ruolo estraneo ai profili (es. `Timesheet` sul cartellino), per cui
// hasSupervisorPermission è false per costruzione.
export default function SupervisorPermissionGuard({ permission, orRoles, children }) {
  const { loading, user } = useAuthContext();

  if (loading) {
    return null;
  }

  if (!hasSupervisorPermission(user, permission) && !hasRole(user, orRoles ?? [])) {
    return <Navigate to={paths.dashboard.root} replace />;
  }

  return <>{children}</>;
}

SupervisorPermissionGuard.propTypes = {
  permission: PropTypes.string.isRequired,
  orRoles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
};
